import React, { useState, useEffect } from 'react';
import { Container, Grid, TextField, Typography, Paper, Box, Button } from '@mui/material';
import MapSearch from './MapSearch';
import BlogList from './BlogList';
import NewsFeed from './NewsFeed';

function SearchDashboard() {
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedTerm, setDebouncedTerm] = useState('');

  // Grab the current year dynamically
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedTerm(searchTerm);
    }, 800);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 8 }}>
      <Typography variant="h3" gutterBottom align="center" sx={{ fontWeight: 'bold', mb: 4 }}>
        {/* Made the dashboard title dynamic */}
        {currentYear} Holiday Search Command Center
      </Typography>
      
      {/* 1. MASTER SEARCH BAR */}
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 6 }}>
        <Paper elevation={4} sx={{ p: 1, width: '100%', maxWidth: 800, display: 'flex' }}>
          <TextField 
            label="Search locations, news, or guides..." 
            variant="outlined" 
            fullWidth 
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ '& fieldset': { border: 'none' } }} 
          />
        </Paper>

        {/* --- LIVE FUEL PRICE SHORTCUT --- */}
        <Box sx={{ mt: 2, display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
          <Button 
            href="https://termplanner.com.au/fuel-app"
            target="_blank"
            rel="noopener noreferrer"
            variant="outlined"
            size="medium"
            sx={{ 
              fontWeight: 'bold', 
              color: '#e65100', 
              borderColor: '#e65100',
              backgroundColor: '#fff3e0',
              boxShadow: '0 2px 8px rgba(230, 81, 0, 0.15)',
              '&:hover': {
                backgroundColor: '#ffe0b2',
                borderColor: '#ef6c00'
              }
            }}
          >
            ⛽ Check Live Fuel Prices for Your Route
          </Button>
        </Box>
        {/* ---------------------------------- */}
      </Box>

      {/* 2. CONTENT SECTION (Top) */}
      <Grid container spacing={4} sx={{ mb: 4 }}>
        {/* A. Blog Results */}
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ p: 2, height: '100%', minHeight: '400px' }}>
            <Typography variant="h5" gutterBottom sx={{ color: '#d32f2f', fontWeight: 'bold' }}>
              Our Guides
            </Typography>
            <BlogList keyword={debouncedTerm} />
          </Paper>
        </Grid>

        {/* B. News Feed */}
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ p: 2, height: '100%', minHeight: '400px' }}>
            <Typography variant="h5" gutterBottom sx={{ color: '#2e7d32', fontWeight: 'bold' }}>
              News: Lead Up to January
            </Typography>
            {/* Added currentYear to the fallback search query to ensure fresh news */}
            <NewsFeed query={debouncedTerm || `Christmas Events ${currentYear}`} />
          </Paper>
        </Grid>
      </Grid>

      {/* 3. MAP SECTION (Bottom - FULL WIDTH & FIXED HEIGHT) */}
      <Box sx={{ width: '100%', mt: 4 }}>
        <Paper 
          elevation={6} 
          sx={{ 
            p: 1, 
            width: '100%', 
            height: '700px', // FORCE HUGE HEIGHT
            overflow: 'hidden',
            borderRadius: 2,
            border: '1px solid #ddd'
          }}
        >
          <Box sx={{ p: 2, borderBottom: '1px solid #eee', mb: 1 }}>
             <Typography variant="h5" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
             Global Map View
            </Typography>
          </Box>
          
          {/* Map Wrapper with Explicit Height */}
          <Box sx={{ height: '600px', width: '100%' }}>
             <MapSearch searchQuery={debouncedTerm} />
          </Box>
        </Paper>
      </Box>

    </Container>
  );
}

export default SearchDashboard;